export enum TaskType {
  CustomerExport = 0,
  RemarkClear  = 1,
  RemarkMerge = 2,
  RemarkImport = 3,
  MassSend = 4,
  Broadcast = 5,
  TemplateSend = 6,
  Sms = 7,
  GroupAppend = 8,
  GroupRemove = 9,
  SyncWxRemark = 10,
  FieldImport = 11,
  WxSubTpl = 12
}

export enum TaskTypeDesc {
  CustomerExport = '粉丝导出',
  RemarkClear = '删除标签',
  RemarkMerge = '合并标签',
  RemarkImport = '导入标签',
  MassSend = '公众号群发',
  Broadcast = '广播',
  TemplateSend = '模板群发',
  Sms = '短信群发',
  GroupAppend = '添加到组',
  GroupRemove = '删除组',
  SyncWxRemark = '同步微信标签',
  FieldImport = '数据导入',
  WxSubTpl = '订阅消息推送',
}

export function getTaskDesc(type: TaskType): string {
  if (type === TaskType.CustomerExport) {
    return TaskTypeDesc.CustomerExport;
  } else if (type === TaskType.RemarkClear) {
    return TaskTypeDesc.RemarkClear;
  } else if (type === TaskType.RemarkMerge) {
    return TaskTypeDesc.RemarkMerge;
  } else if (type === TaskType.RemarkImport) {
    return TaskTypeDesc.RemarkImport;
  } else if (type === TaskType.MassSend) {
    return TaskTypeDesc.MassSend;
  } else if (type === TaskType.Broadcast) {
    return TaskTypeDesc.Broadcast;
  } else if (type === TaskType.TemplateSend) {
    return TaskTypeDesc.TemplateSend;
  } else if (type === TaskType.Sms) {
    return TaskTypeDesc.Sms;
  } else if (type === TaskType.GroupAppend) {
    return TaskTypeDesc.GroupAppend;
  } else if (type === TaskType.GroupRemove) {
    return TaskTypeDesc.GroupRemove;
  } else if (type === TaskType.SyncWxRemark) {
    return TaskTypeDesc.SyncWxRemark;
  } else if (type === TaskType.FieldImport) {
    return TaskTypeDesc.FieldImport;
  } else if(type === TaskType.WxSubTpl) {
    return TaskTypeDesc.WxSubTpl
  } else {
    return '';
  }
}
